import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import HeaderLogo from './header/HeaderLogo';
import DesktopNav from './header/DesktopNav';
import HeaderControls from './header/HeaderControls';
import MegaMenu from './header/MegaMenu';
import MobileMenu from './header/MobileMenu';
import { TRANSPARENT_AT_TOP_ROUTES } from './header/navData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { darkMode, toggleDarkMode } = useTheme();
  const timerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setActiveMenu(null);
  }, [location.pathname]);

  const openMenu = (key) => {
    clearTimeout(timerRef.current);
    setActiveMenu(key);
  };
  const closeMenu = () => {
    timerRef.current = setTimeout(() => setActiveMenu(null), 150);
  };
  const keepMenu = () => clearTimeout(timerRef.current);

  const allowsTransparent = TRANSPARENT_AT_TOP_ROUTES.has(location.pathname);
  const isSolid = !allowsTransparent || scrolled || mobileOpen;
  const headerBg = isSolid ? 'bg-mcx-white border-b border-mcx-mist shadow-sm' : 'bg-transparent';
  const textCls = isSolid ? 'text-mcx-ink' : 'text-white';
  const hoverCls = isSolid ? 'hover:bg-mcx-paper' : 'hover:bg-white/10';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBg}`}
      data-testid="site-header"
    >
      <a href="#main-content" className="skip-link">Skip to main content</a>

      <div className="max-w-content mx-auto px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <HeaderLogo isSolid={isSolid} />
          <DesktopNav
            activeMenu={activeMenu}
            openMenu={openMenu}
            closeMenu={closeMenu}
            textCls={textCls}
            hoverCls={hoverCls}
          />
          <HeaderControls
            textCls={textCls}
            hoverCls={hoverCls}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
          />
        </div>
      </div>

      <MegaMenu activeMenu={activeMenu} keepMenu={keepMenu} closeMenu={closeMenu} />

      {mobileOpen && <MobileMenu />}
    </header>
  );
}
